<nav class="flex" aria-label="Breadcrumb">
    <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
        <li class="inline-flex items-center" *ngFor="let item of items; let last = last; let first = first">
            <a *ngIf="!last" (click)="onClick(item)"
                class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
                <!-- <ng-container *ngIf="first">
                    <mat-icon class="mr-2">home</mat-icon>
                </ng-container> -->
                {{ item.name | translate }}
            </a>
            <div class="flex items-center" *ngIf="!last">
                <mat-icon>chevron_right</mat-icon>
            </div>
            <span *ngIf="last" class="ms-1 text-sm font-medium text-gray-500 md:ms-2 dark:text-gray-400">
                {{ item.name | translate }}
            </span>
        </li>
    </ol>
</nav>